import React from 'react'
import { Modal, Form, Select, DatePicker, Input, Button, theme } from 'antd'
import { PlusOutlined, CloseOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Option } = Select

const AddTaskModal = ({ isVisible, onCancel, onAdd, form, filterValues }) => {
  const { token } = theme.useToken()
  const { categories, staffMembers, priorities } = filterValues

  return (
    <Modal
      title='Create New Task'
      visible={isVisible}
      onCancel={onCancel}
      footer={[
        <Button
          key='cancel'
          onClick={onCancel}
          icon={<CloseOutlined style={{ color: token.colorError }} />}
          style={{
            background: hexToRGBA(token.colorError, 0.1),
            borderColor: token.colorError,
            color: token.colorError
          }}
        >
          Cancel
        </Button>,
        <Button
          key='submit'
          onClick={onAdd}
          icon={<PlusOutlined style={{ color: token.colorSuccess }} />}
          style={{
            background: hexToRGBA(token.colorSuccess, 0.1),
            borderColor: token.colorSuccess,
            color: token.colorSuccess,
            fontWeight: 'bold'
          }}
        >
          Create Task
        </Button>
      ]}
      width={700}
    >
      <Form form={form} layout='vertical'>
        <Form.Item name='patientId' label='Patient' rules={[{ required: true, message: 'Please select a patient' }]}>
          <Select placeholder='Select patient' showSearch optionFilterProp='children'>
            <Option value='PT-1001'>John Smith (PT-1001)</Option>
            <Option value='PT-1023'>Emma Wilson (PT-1023)</Option>
            <Option value='PT-1045'>Michael Brown (PT-1045)</Option>
            {/* More options would be populated from patients database */}
          </Select>
        </Form.Item>

        <Form.Item
          name='taskDescription'
          label='Task Description'
          rules={[{ required: true, message: 'Please enter task description' }]}
        >
          <Input.TextArea rows={2} />
        </Form.Item>

        <Form.Item name='category' label='Category' rules={[{ required: true, message: 'Please select a category' }]}>
          <Select placeholder='Select category'>
            {categories.map((category) => (
              <Option key={category} value={category}>
                {category}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='assignedTo'
          label='Assign To'
          rules={[{ required: true, message: 'Please assign staff member' }]}
        >
          <Select placeholder='Select staff member'>
            {staffMembers.map((staff) => (
              <Option key={staff} value={staff}>
                {staff}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name='priority' label='Priority' rules={[{ required: true, message: 'Please select priority' }]}>
          <Select placeholder='Select priority'>
            {priorities.map((priority) => (
              <Option key={priority} value={priority}>
                {priority}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='dueDate'
          label='Due Date/Time'
          rules={[{ required: true, message: 'Please specify due date/time' }]}
        >
          <DatePicker showTime format='YYYY-MM-DD HH:mm' style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item name='taskNotes' label='Task Notes'>
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default AddTaskModal
